/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {preinitializeAdminUsers} from '@ion/applications/src/pages/admin/users/state';
import Hidden from '@ion/dls/src/layout/Hidden';
import useCurrentUser from '@ion/query/src/hooks/useCurrentUser';
import {responsiveHeaderSelector} from '@/store/selectors/header';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import ToastNotificationWrapper from './ToastNotificationWrapper';

/**
 * @ResponsiveHeader
 */
const ResponsiveHeader = () => {
  const dispatch         = useDispatch();
  const {currentUser}    = useCurrentUser();
  const isProfleEnabled  = useSelector(responsiveHeaderSelector);

  useEffect(() => {
    if (!isProfleEnabled && !!currentUser?.id) {
      dispatch(preinitializeAdminUsers());
    }
  }, [currentUser]);

  return (
    <div>
      <Hidden show='desktop'>
        <DesktopHeader />
      </Hidden>
      <Hidden show='mobile'>
        <MobileHeader />
      </Hidden>
      <ToastNotificationWrapper />
    </div>
  );
};
export default ResponsiveHeader;
